import script from "./MallMyFilterBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallMyFilterBar.vue?vue&type=script&setup=true&lang=ts"

import "./MallMyFilterBar.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__